/**
 * A reserved space for a static banner (docs/MONETIZATION.md § 2). The slot
 * has a fixed height, so a banner appearing never moves the buttons around it.
 * Renders nothing at all when ads are off.
 */
import { useEffect, useRef } from 'react';
import type { AdPlacement, AdsService } from '../contracts.ts';
import { getLocale, useT } from '../i18n/index.ts';
import './ui.css';

export interface AdSlotProps {
  ads: AdsService;
  slot: AdPlacement;
  /** From entitlements (useEntitlements), so buying Remove Ads re-renders without the slot. */
  enabled: boolean;
}

export function AdSlot({ ads, slot, enabled }: AdSlotProps) {
  const ref = useRef<HTMLDivElement>(null);
  useT(); // re-render on a language switch…
  // …and redraw the banner then: its text is written once, in the language of the moment.
  const locale = getLocale();

  useEffect(() => {
    const el = ref.current;
    if (!enabled || !el) return;
    return ads.showBanner(slot, el);
  }, [ads, slot, enabled, locale]);

  if (!enabled) return null;
  return <div ref={ref} className="ui-ad-slot" data-slot={slot} />;
}
